import React from 'react';
import {
    Typography,
    Box,
    Avatar,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const TestimonialColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {row.thumbnail && (
                        <Avatar
                            src={row.thumbnail}
                            sx={{ width: 56, height: 56 }}
                        />
                    )}
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {value}
                    </Typography>
                </Box>
            );
        }
    },
    {
        id: "message",
        label: "Message",
        render: (value, row) => {
            return (
                <Typography 
                    variant="body2" 
                    sx={{ 
                        maxWidth: 400,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {value}
                </Typography>
            );
        }
    },
    {
        id: "date",
        label: "Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
    {
        id: "created_at",
        label: "Created Date",
        render: (value, row) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
